import React from 'react';

const DashboardSummarySkeleton = () => {
  return (
    <section
      role="status"
      aria-label="Loading dashboard"
      className="animate-pulse space-y-6 px-4 sm:px-6"
    >
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="space-y-2">
          <div className="h-6 w-40 bg-gray-200 rounded-md" />
          <div className="h-4 w-32 bg-gray-200 rounded-md" />
        </div>

        <div className="flex items-center gap-3">
          <div className="h-8 w-8 bg-gray-300 rounded-full" />
          <div className="h-8 w-20 bg-gray-200 rounded-md" />
        </div>
      </div>

      {/* Overview pills */}
      <div className="bg-white border rounded-[10px] p-4">
        <ul className="flex flex-col sm:flex-row sm:divide-x sm:divide-gray-100 gap-3 sm:gap-6">
          {['Ongoing', 'Completed', 'Cancelled'].map((_, i) => (
            <li key={i} className="flex-1 flex items-center justify-between gap-3">
              <div className="space-y-2 w-full">
                <div className="h-4 w-24 bg-gray-200 rounded" />
                <div className="flex items-center gap-3">
                  <div className="h-8 w-8 bg-gray-300 rounded-full" />
                  <div className="h-6 w-14 bg-gray-200 rounded" />
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>

      {/* Main grid */}
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-[38%_60%]">
        {/* Left card */}
        <div className="bg-white border rounded-[10px] p-4 min-h-[180px] flex flex-col gap-3">
          <div className="h-5 w-1/2 bg-gray-200 rounded" />
          <div className="flex-1 grid grid-cols-2 gap-3 mt-2">
            <div className="space-y-2">
              <div className="h-4 w-full bg-gray-200 rounded" />
              <div className="h-10 bg-gray-200 rounded" />
            </div>
            <div className="space-y-2">
              <div className="h-4 w-full bg-gray-200 rounded" />
              <div className="h-10 bg-gray-200 rounded" />
            </div>
          </div>
          <div className="h-8 w-3/5 bg-gray-200 rounded self-start mt-2" />
        </div>

        {/* Right column */}
        <div className="space-y-4">
          <div className="flex items-center justify-between">
            <div className="h-6 w-40 bg-gray-200 rounded" />
            <div className="h-4 w-20 bg-gray-200 rounded" />
          </div>

          <div className="bg-white border rounded-[10px] p-4">
            <div className="grid gap-3">
              {[1, 2].map((_, i) => (
                <div key={i} className="flex items-center justify-between gap-4">
                  <div className="flex items-center gap-3">
                    <div className="h-10 w-10 bg-gray-300 rounded-md" />
                    <div className="space-y-1">
                      <div className="h-4 w-40 bg-gray-200 rounded" />
                      <div className="h-3 w-28 bg-gray-200 rounded" />
                    </div>
                  </div>
                  <div className="h-4 w-20 bg-gray-200 rounded" />
                </div>
              ))}
            </div>
          </div>

          {/* Activity / table skeleton */}
          <div className="bg-white border rounded-[10px] p-4 overflow-hidden">
            <div className="h-4 w-32 bg-gray-200 rounded mb-3" />
            <div className="grid gap-3">
              {[1, 2, 3, 4].map((_, i) => (
                <div key={i} className="flex items-center justify-between gap-4">
                  <div className="flex-1 flex items-center gap-3">
                    <div className="h-8 w-8 bg-gray-300 rounded" />
                    <div className="w-full">
                      <div className="h-3 w-3/4 bg-gray-200 rounded mb-2" />
                      <div className="h-2 w-1/2 bg-gray-200 rounded" />
                    </div>
                  </div>
                  <div className="h-3 w-16 bg-gray-200 rounded" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      <span className="sr-only">Loading...</span>
    </section>
  );
};

export default DashboardSummarySkeleton;